<template>
  <v-card>
    <v-container
      fluid>
      <v-row
        justify=center
        align=center>
        <v-col
          cols=auto>
          <v-icon
            size=100
            color=blue>fa-laptop-code</v-icon>
        </v-col>
        <v-col
          cols=12
          md=9>
          <v-container
            class="no--vertical--paddings">
            <v-row
              justify=center
              justify-md=start>
              <v-col
                cols=auto
                md=12
                class="no--vertical--paddings">
                <h3>本格的プログラミングスキル</h3>
              </v-col>
              <v-col
                cols=12>
                『Python』、『JavaScript』といった、実際に開発現場でも用いられているプログラミング言語を学びます。最初は難しいかもしれませんが、つまづきポイントは担当講師がしっかりとキャッチアップします。
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row
        justify=center
        align=center>
        <v-col
          cols=auto>
          <v-icon
            size=100
            color=blue>mdi-function-variant</v-icon>
        </v-col>
        <v-col
          cols=12
          md=9>
          <v-container
            class="no--vertical--paddings">
            <v-row
              justify=center
              justify-md=start>
              <v-col
                cols=auto
                md=12
                class="no--vertical--paddings">
                <h3>論理的思考力</h3>
              </v-col>
              <v-col
                cols=12>
                プログラミングに欠かせない、問題の細分化や、論理の道筋の考え方が自然と身につきます。担当講師との対話を通して、考えるのと同時に、アウトプットする（伝える）経験も得ることができます。
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row
        justify=center
        align=center>
        <v-col
          cols=auto>
          <v-icon
            size=100
            color=blue>fa-robot</v-icon>
        </v-col>
        <v-col
          cols=12
          md=9>
          <v-container
            class="no--vertical--paddings">
            <v-row
              justify=center
              justify-md=start>
              <v-col
                cols=auto
                md=12
                class="no--vertical--paddings">
                <h3>コンピュータ全般の知識</h3>
              </v-col>
              <v-col
                cols=12>
                本格的なプログラミング言語の学習と通して、「コンピュータの仕組み」、「Webとはなにか」といった知識を習得できます。機械に仕事を奪われるのではなく、機械を使いこなす人材になれるよう、全力でサポートします。
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  
}
</script>

<style scoped>
.no--vertical--paddings {
  padding: 0px 12px;
}
</style>
